import type { AdminSession } from "@/api/types";

const KEY = "gridcast-admin:session";

let cached: AdminSession | null | undefined;

export function getSession(): AdminSession | null {
	if (cached !== undefined) return cached;
	try {
		const raw = localStorage.getItem(KEY);
		cached = raw ? (JSON.parse(raw) as AdminSession) : null;
	} catch {
		cached = null;
	}
	return cached;
}

export function setSession(session: AdminSession | null) {
	cached = session;
	if (session) localStorage.setItem(KEY, JSON.stringify(session));
	else localStorage.removeItem(KEY);
}
